<div id="contextMenu" class="context-container" [style.top.px]="top" [style.left.px]="left">
  <div class="context-title">
    {{ headerText }}
  </div>
  <div class="context-body">
    <ng-content></ng-content>
  </div>
</div>
